const translateIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:hsl(0, 0%, 62.9%);"  viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"></path>
</svg>`;

const summarizeIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:hsl(0, 0%, 62.9%);"  viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"></path>
</svg>
`;

const findActionItemsIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:hsl(0, 0%, 62.9%);"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"></path>
</svg>
`;

const explainIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:hsl(0, 0%, 62.9%);"  viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"></path>
</svg>
`;

const essenceIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:hsl(0, 0%, 62.9%);"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path>
</svg>
`;

const keyPointsIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:hsl(0, 0%, 62.9%);"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"></path>
</svg>
`;

const messageIcon = `
<svg style="width:20px; height:20px; fill:#bbb;"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"></path>
</svg>
`;

const chatSendIcon = `
<svg style="width:18px; height:18px;" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"></path>
</svg>
`;

const stopIcon = `
<svg style="width:22px; height:22px"  viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"></path>
</svg>
`

const openChatIcon = `
<svg style="width:20px; height:20px; fill:#fff; padding-top: 2px"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"></path>
</svg>
`;

const trashIcon = `
<svg class='dropdown-item-icon' style="width:12px; height:12px; fill:#fff;"  viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"></path>
</svg>
`;

const settingsIcon = `
<svg style="width:20px; height:20px; fill:#8e8e8e;"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"></path>
</svg>
`;

const expandIcon = `
<svg style="width:18px; height:18px; fill:#8e8e8e;"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"></path>
</svg>
`;

const shrinkIcon = `
<svg style="width:18px; height:18px; fill:#8e8e8e;"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"></path>
</svg>
`;

const modalHTML = `
    <div class="config-window position-absolute d-flex flex-column d-none">
      <h4 class="h4">Settings</h4>
      <form class="config-form d-flex flex-column">
        <div class="form-group d-flex align-items-center">
          <input type="checkbox" id="addCommentsToContext">
          <label for="addCommentsToContext">Add comments to the context (only in page preview mode)</label>
        </div>
        <div class="form-group d-flex align-items-center">
          <input type="number" min="0" id="chatHistoryContextLength">
          <label for="chatHistoryContextLength">Messages limit in context</label>
        </div>
        <div class="success-feedback d-none">Chat history successfully removed!</div>
        <div class="error-feedback d-none">Something went wrong while removing chat history!</div>
        <button class="clear-chat" type="button">${trashIcon} Clear chat history</button>
        <button class="config-form-submit-button" type="submit">Save changes</button>
      </form>
    </div>
    <div class="d-flex flex-column">
      <div class="ask-ai-chat-header d-flex">
        <div class="d-flex align-items-center">
          <div class="header-message-button d-inline" role="button" tabindex="0">
            ${messageIcon} 
          </div>
          <h3 class="ask-ai-chat-title">Chat with AI</h3>
        </div>
        <div class="d-flex">
          <button type="button" role="button" class="settings-chat-btn d-flex">
            ${settingsIcon}
          </button>
          <button type="button" role="button" class="shrink-chat-btn d-flex d-none">
            ${shrinkIcon}
          </button>
          <button type="button" role="button" class="expand-chat-btn d-flex">
            ${expandIcon}
          </button>
          <button type="button" role="button" class="close-chat-btn d-flex">
          <svg style="width:24px; height:24px; fill:#8b8989;"  viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
            <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
          </svg>
          </button>
        </div>
      </div>
    <div class="predefined-actions w-100 row">
      <div class="predefined-action-wrapper col-6">
        <div role="button" tabindex="0" class="predefined-action d-flex">
          <div class="predefined-action-icon d-flex">${summarizeIcon}</div>
          <div class="predefined-action-details">
            <div class="predefined-action-label">Summarize</div>
            <div class="predefined-action-value">/summarize</div>
          </div>
        </div>
      </div>
      <div class="predefined-action-wrapper col-6">
        <div role="button" tabindex="0" class="predefined-action d-flex">
          <div class="predefined-action-icon d-flex">${translateIcon}</div>
          <div class="predefined-action-details">
            <div class="predefined-action-label">Translate</div>
            <div class="predefined-action-value">/translate</div>
          </div>
        </div>
      </div>
      <div class="predefined-action-wrapper col-6">
        <div role="button" tabindex="0" class="predefined-action d-flex">
          <div class="predefined-action-icon d-flex">${findActionItemsIcon}</div>
          <div class="predefined-action-details">
            <div class="predefined-action-label">Find action items</div>
            <div class="predefined-action-value">/find-action-items</div>
          </div>
        </div>
      </div>
      <div class="predefined-action-wrapper col-6">
        <div role="button" tabindex="0" class="predefined-action d-flex">
          <div class="predefined-action-icon d-flex">${explainIcon}</div>
          <div class="predefined-action-details">
            <div class="predefined-action-label">Explain this</div>
            <div class="predefined-action-value">/explain</div>
          </div>
        </div>
      </div>
      <div class="predefined-action-wrapper col-6">
        <div role="button" tabindex="0" class="predefined-action d-flex">
          <div class="predefined-action-icon d-flex">${essenceIcon}</div>
          <div class="predefined-action-details">
            <div class="predefined-action-label">Essence</div>
            <div class="predefined-action-value">/essence</div>
          </div>
        </div>
      </div>
      <div class="predefined-action-wrapper col-6">
        <div role="button" tabindex="0" class="predefined-action d-flex">
          <div class="predefined-action-icon d-flex">${keyPointsIcon}</div>
          <div class="predefined-action-details">
            <div class="predefined-action-label">Key points</div>
            <div class="predefined-action-value">/key-points</div>
          </div>
        </div>
      </div>

    </div>
      <div class="chat-window d-flex">
        <div class="d-flex flex-column chat-messages">
          <div class="ai-message-wrapper d-flex">
            <div class="d-flex chat-message ai-message">
              <div class="chat-message-text">Hello, how can I help you today?</div>
            </div>
          </div>
        </div>
      </div>
        <form class="chat-form-outline d-flex">
          <input class="chat-input" type="text" placeholder="Type message...">
          <button class="chat-send-btn">${chatSendIcon}</button>
          <button type="button" class="chat-stop-btn d-none">${stopIcon}</button>
        </form>
      </div>
`;

const aiMessagePlaceholder = `
  <div class="ai-message-wrapper d-flex">
    <div class="d-flex chat-message ai-message">
      <div class="chat-message-placeholder"><span class="jumping-dots d-flex"><span>.</span><span>.</span><span>.</span></span></div>
    </div>
  </div>
`;

const defaultOptions = {
  addCommentsToContext: false,
  chatHistoryLength: 10,
};

const csrfToken = document.querySelector('meta[name=token]').getAttribute('content');
const pageEditPattern = /^(https?:\/\/[^\/]+)\/books\/([^\/]+)\/page\/([^\/]+)\/edit$/;
const pageDraftPattern = /^(https?:\/\/[^\/]+)\/books\/([^\/]+)\/draft\/([^\/]+)$/;

const getComments = () => {
  const commentBoxes = Array.from(document.querySelectorAll(".comment-box"));
  const comments = commentBoxes.slice(0, -1).map((comment) => {
    const author = comment.querySelector(".user-profile-link").textContent;
    const commentContent = comment.querySelector(".comment-content").textContent;

    return { author, commentContent };
  });

  return JSON.stringify(comments);
};

const stopStreamResponse = async (reader) => {
    if (reader) {
        await reader.cancel();
        reader = null;
    }
};

class AskAiChat {
  init() {
    const localStorageOptions = JSON.parse(localStorage.getItem("ask-ai-chat-options") || "{}");
    const bookName = window.location.pathname.split('/books/')[1].split('/page')[0];
    let pageName;
    if (window.location.pathname.split('/page/')[1]?.split('/edit')[0]) {
      pageName = window.location.pathname.split('/page/')[1].split('/edit')[0];
    } else {
      pageName = window.location.pathname.split('/books/')[1].split('/draft/')[0]
    }

    this.reader = null;
    this.options = { ...defaultOptions, ...localStorageOptions };

    this.modal = document.createElement("div");
    this.modal.innerHTML = modalHTML;
    this.modal.classList.add("ask-ai-chat-modal");
    this.modal.classList.add("d-flex");
    this.modal.classList.add("flex-column");

    this.closeButton = this.modal.querySelector(".close-chat-btn");
    this.closeButton.addEventListener("click", () => this.closeModal());

    this.expandButton = this.modal.querySelector(".expand-chat-btn");
    this.expandButton.addEventListener("click", () => this.expandModal());

    this.shrinkButton = this.modal.querySelector(".shrink-chat-btn");
    this.shrinkButton.addEventListener("click", () => this.shrinkModal());

    this.input = this.modal.querySelector(".chat-input");
    this.sendBtn = this.modal.querySelector(".chat-send-btn");
    this.stopBtn = this.modal.querySelector(".chat-stop-btn");

    this.aiMessagePlaceholder = document.createElement("div");
    this.aiMessagePlaceholder.innerHTML = aiMessagePlaceholder;
    this.aiMessagePlaceholder.classList.add("ai-message-wrapper");
    this.aiMessagePlaceholder.classList.add("d-flex");

    this.configWindow = this.modal.querySelector(".config-window");
    this.configForm = this.configWindow.querySelector("form");
    this.chatForm = this.modal.querySelector(".chat-form-outline");

    this.configSaveBtn = this.configWindow.querySelector(".config-save-btn");
    this.settingsModeBtn = this.modal.querySelector(".settings-chat-btn");

    this.chatMessages = this.modal.querySelector(".chat-messages");
    this.chatWindow = this.modal.querySelector(".chat-window");
    document.body.appendChild(this.modal);
    const wrapper = document.createElement("div");
    wrapper.classList.add("open-chat-btn-wrapper");
    const label = document.createElement("div");
    label.innerText = "AI Chat";
    this.openBtn = document.createElement("button");
    this.openBtn.innerHTML = openChatIcon;
    this.openBtn.classList.add("open-chat-btn");
    this.openBtn.setAttribute("aria-label", "Open AI Chat");
    this.openBtn.setAttribute("title", "Open AI Chat");

    this.headerMessageButton = document.querySelector('.header-message-button');

    wrapper.appendChild(label);
    wrapper.appendChild(this.openBtn);
    document.body.appendChild(wrapper);
    this.openBtn
      .closest(".open-chat-btn-wrapper")
      .addEventListener("click", () => this.openModal());
    this.chatHistory = localStorage.getItem(`CVDocs-chatHistory-${bookName}-${pageName}`)
      ? JSON.parse(localStorage.getItem(`CVDocs-chatHistory-${bookName}-${pageName}`))
      : [];

    if (this.options.addCommentsToContext) {
      document
        .querySelector("#addCommentsToContext")
        .setAttribute("checked", this.options.addCommentsToContext);
    }
    document.querySelector("#chatHistoryContextLength").value = this.options.chatHistoryLength;

    // modal's open btn is in the same place as the back-to-top button, so we need to hide/remove it
    const backToTopBtn = document.querySelector(".back-to-top");
    if (backToTopBtn) {
      backToTopBtn.classList.add("d-none");
    }

    if (this.chatHistory.length > 0) {
      this.chatHistory.forEach((message) => {
        if (message.author === "ai") {
          this._addAiResponse(message.content);
        } else {
          this._addUserMessage(message.content);
        }
      });
    }

    this.settingsModeBtn.addEventListener("click", () => {
      if (this.configWindow.classList.contains("d-none")) {
        this.configWindow.classList.remove("d-none");
        this.headerMessageButton.style.cursor = "pointer";
      } else {
        this.configWindow.classList.add("d-none");
        this.headerMessageButton.style.cursor = "default";
      }
    });

    this.configForm.addEventListener("submit", (e) => {
      e.preventDefault();
      this.options.addCommentsToContext = document.querySelector("#addCommentsToContext").checked;
      this.options.chatHistoryLength = document.querySelector("#chatHistoryContextLength").value;
      this.configWindow.classList.add("d-none");
      localStorage.setItem("ask-ai-chat-options", JSON.stringify(this.options));
    });

    this._handleSubmit = (e) => {
      e.preventDefault();
      if (this.input.value === "") return;
      this._sendUserMessage(this.input.value);
      this.chatForm.reset();
    };

    this.chatForm.addEventListener("submit", this._handleSubmit);

    this.stopBtn.addEventListener("click", () => {
      stopStreamResponse(this.reader);
    });

    this.configWindow.querySelector("button.clear-chat").addEventListener("click", () => {
      const successFeedback = document.querySelector('.success-feedback');
      const errorFeedback = document.querySelector('.error-feedback');
      try {
        this.chatMessages.innerHTML = "";
        this.chatHistory = [];
        for (const [key, value] of Object.entries(localStorage)) {
          if (key.startsWith("CVDocs-chatHistory")) {
            localStorage.removeItem(key);
          }
        }
        successFeedback.classList.remove('d-none');
      }
      catch (error) {
        errorFeedback.classList.remove('d-none');
      }

      setTimeout(() => {
        successFeedback.classList.add('d-none');
        errorFeedback.classList.add('d-none');
      }, 7000);
    });

    document.querySelectorAll(".predefined-action").forEach((predefinedAction) => {
      predefinedAction.addEventListener("click", () => {
        this._sendUserMessage(
          predefinedAction.querySelector(".predefined-action-value").textContent
        );
      });
    });

    this.headerMessageButton.addEventListener('click', () => {
      if (!this.configWindow.classList.contains("d-none")) { 
        this.configWindow.classList.add("d-none");
        this.headerMessageButton.style.cursor = "default";
      }
    })
  }


  openModal() {
    this.modal.classList.add("open");
    this.chatWindow.scrollTo(0, this.chatMessages.scrollHeight);
  }

  closeModal() {
    this.modal.classList.remove("open");
    this.shrinkModal();
  }

  toggleInputButtons() {
    this.stopBtn.classList.toggle("d-none");
    this.sendBtn.classList.toggle("d-none");
  }

  expandModal() {
    this.modal.classList.add("expanded");
    this.expandButton.classList.add("d-none");
    this.shrinkButton.classList.remove("d-none");
  }

  shrinkModal() {
    this.modal.classList.remove("expanded");
    this.expandButton.classList.remove("d-none");
    this.shrinkButton.classList.add("d-none");
  }

  _addAiResponse(response = "") {
    const responseWrapper = document.createElement("div");
    responseWrapper.classList.add("ai-message-wrapper");
    responseWrapper.innerHTML = `<div class="chat-message ai-message"></div>`;
    const chatTextElement = document.createElement("div");
    chatTextElement.classList.add("chat-message-text");
    chatTextElement.innerHTML = response;

    const aiMessageEl = responseWrapper.querySelector(".ai-message");
    aiMessageEl.appendChild(chatTextElement);

    this.chatMessages.appendChild(responseWrapper);
    this.chatWindow.scrollTo(0, this.chatMessages.scrollHeight);

    return aiMessageEl;
  }

  _editAiResponse(aiMessageEl, response) {
    aiMessageEl.innerHTML = response;
    this.chatWindow.scrollTo(0, this.chatMessages.scrollHeight);
  }

  _addUserMessage(message) {
    const messageElement = document.createElement("div");
    messageElement.classList.add("user-message-wrapper");
    messageElement.innerHTML = `
        <div class="chat-message user-message">
          <div class="chat-message-text">${message}</div>
        </div>
      `;
    this.modal.querySelector(".chat-messages").appendChild(messageElement);
  }
  async _sendUserMessage(message) {
    const bookName = window.location.pathname.split('/books/')[1].split('/page')[0];
    let pageName;
    if (window.location.pathname.split('/page/')[1]?.split('/edit')[0]) {
      pageName = window.location.pathname.split('/page/')[1].split('/edit')[0];
    } else {
      pageName = window.location.pathname.split('/books/')[1].split('/draft/')[0]
    }

    this._addUserMessage(message);
    const aiResponse = await this._askAi(message);

    // this._addAiResponse(aiResponse);
    this.chatHistory.push({ author: "user", content: message });
    this.chatHistory.push({ author: "ai", content: aiResponse });
    localStorage.setItem(`CVDocs-chatHistory-${bookName}-${pageName}`, JSON.stringify(this.chatHistory));
  }

  async _askAi(message) {
    const isPageEdit = pageEditPattern.test(window.location.href);
    const isPageDraft = pageDraftPattern.test(window.location.href);
    this.input.setAttribute("disabled", "disabled");
    this.sendBtn.setAttribute("disabled", "disabled");
    let language = "";
    let pageContent;
    const predefinedActions = [
      "/summarize",
      "/translate",
      "/find-action-items",
      "/explain",
      "/essence",
      "/key-points",
    ];
    const isPredefinedAction = predefinedActions.includes(message);
    if (isPageEdit || isPageDraft) {
      pageContent = document.querySelector("#html-editor_ifr").contentDocument.body.innerHTML;
    } else {
      pageContent = document.querySelector(".page-content").innerHTML;
    }
    this._addAiMessagePlaceholder();
    if (message === "/translate") {
      setTimeout(() => {
        const response = this._addAiResponse();
        this._removeAiMessagePlaceholder();
        this._editAiResponse(response, "What language would you like to translate to?");
        this.input.removeAttribute("disabled");
        this.sendBtn.removeAttribute("disabled");
      }, 500);

      this.chatForm.removeEventListener("submit", this._handleSubmit);
      language = await new Promise((resolve) => {
        this.chatForm.addEventListener(
          "submit",
          (e) => {
            e.preventDefault();
            resolve(this.chatForm.querySelector("input").value);
            this.chatForm.reset();
          },
          { once: true }
        );
      });
      this._addUserMessage(language);
      this._addAiMessagePlaceholder();
      this.chatForm.addEventListener("submit", this._handleSubmit);
    }

    const response = await fetch(
      `${window.location.origin}/ai/ask-chat/${
        isPredefinedAction ? message.replace("/", "") : "ask"
      }`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": csrfToken,
        },
        body: JSON.stringify({
          context: pageContent,
          message: message === "/translate" ? language : message,
          chatHistory: JSON.stringify(this.chatHistory.slice(-this.options.chatHistoryLength)),
          comments: this.options.addCommentsToContext ? getComments() : "",
        }),
      }
    );

    this.toggleInputButtons();
    this._removeAiMessagePlaceholder();
    const aiResponseEl = this._addAiResponse();

    if (response.status !== 200) { 
      try {
        const resJson = await response.json();
        this._editAiResponse(aiResponseEl, resJson.error);
      } catch {
        this._editAiResponse(aiResponseEl, "An error occurred while processing your request. Please try again later.");
      }
      this.input.removeAttribute("disabled");
      this.sendBtn.removeAttribute("disabled");
      this.toggleInputButtons();
      return;
    }

    this.reader = response.body.getReader();
    const decoder = new TextDecoder();

    let res = "";
    // eslint-disable-next-line no-constant-condition
    while (true) {
      // eslint-disable-next-line no-await-in-loop
      const { done, value } = await this.reader.read();

      if (done) {
        this.input.removeAttribute("disabled");
        this.sendBtn.removeAttribute("disabled");
        this.toggleInputButtons();
        break;
      } // Exit the loop if the stream is finished

      // Decode and append the chunk of data to the container
      res += decoder.decode(value);
      this._editAiResponse(aiResponseEl, res);
    }
    return res;
  }

  _addAiMessagePlaceholder() {
    this.chatMessages.appendChild(this.aiMessagePlaceholder);
    this.chatWindow.scrollTo(0, this.chatMessages.scrollHeight);
  }

  _removeAiMessagePlaceholder() {
    this.chatMessages.removeChild(this.aiMessagePlaceholder);
    this.chatWindow.scrollTo(0, this.chatMessages.scrollHeight);
  }
}

export default AskAiChat;
